<template>
  <div class="container mt-5 mb-5">
		<div class="row justify-content-center">
			<div class="col-md-12 ">			
				<iframe width="100%"    :src="iframeSrc"    :style="{ height: iframeHeight  }"    frameborder="0"    scrolling="no"  />
			</div>
	
		</div>
	</div>
</template>

<script>
export default {
  name: "DataIframe",
  props: {
    iframeSrc: {
      type: String,
      required: true,
    },
    iframeHeight: {
      type: String,
      required: false,
      default: "620px",
    },
  },
  mounted() {
    window.addEventListener("message", this.adjustIframeHeight);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.adjustIframeHeight);
  },
  methods: {
    adjustIframeHeight(event) {
      if (event.data && event.data["datawrapper-height"]) {
        var iframes = this.$el.querySelectorAll("iframe");
        for (var iframeId in event.data["datawrapper-height"]) {
          for (var i = 0; i < iframes.length; i++) {
            if (iframes[i].contentWindow === event.source) {
              var height = event.data["datawrapper-height"][iframeId] + "px";
              iframes[i].style.height = height;
            }
          }
        }
      }
    },
  },
};
</script>
